(function () {
  var STORAGE_KEY = 'lg_cookie_consent';
  var el, acceptBtn;

  function init() {
    el = document.getElementById('lg-cookie-consent');
    if (!el) return;
    acceptBtn = document.getElementById('lg-cookie-accept');

    var consent;
    try { consent = window.localStorage.getItem(STORAGE_KEY); } catch (e) { consent = null; }

    if (consent === 'accepted') return;

    el.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('is-visible'); });
    });

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        try { window.localStorage.setItem(STORAGE_KEY, 'accepted'); } catch (e) {}
        el.classList.remove('is-visible');
        setTimeout(function () { el.hidden = true; }, 500);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
